export default __webpack_public_path__ + "static/media/arrow-right.50297674.svg";